import { createAction } from '@reduxjs/toolkit';

const fetchIbaAsync = createAction('iba/fetchIbaAsync');
const setIba = createAction('iba/setIba');

export default {
  fetchIbaAsync,
  setIba,
};
